import { intl } from "LocaleWrapper";
import { CustomDialog } from "components/dialogs/Dialogs";
import ContractSendHistory from "components/finance/ContractSendHistory";
import { ContractHistoryItem } from "types/index";

type ContractHistoryDialogProps = {
	open: boolean;
	onClose: () => void;
	history: ContractHistoryItem[]
};

const ContractHistoryDialog = ({ open, onClose, history = [] }: ContractHistoryDialogProps) => {
	return (
		<CustomDialog
			open={open}
			onClose={onClose}
			title={intl.formatMessage({ id: "HISTORY" })}
			maxWidth="md">
			<ContractSendHistory history={history} />
		</CustomDialog>
	);
};

export default ContractHistoryDialog;
